import { FishingReport, SeasonGroup, Species } from '@omniafishing/core';
import React from 'react';
import { useFishingReportListViewed } from '../../hooks/use_fishing_report_list_viewed';
// import { useResponsive } from '../../hooks/use_responsive';
import Loading from '../../components/loading/loading';
import { MapFishingReportCard } from '../../components/map/map_modals/featured_reports_modal/map_fishing_report_card';
import { OmniaButton } from '../../components/omnia_button/omnia_button';
import { Spacer } from '../../components/spacer/spacer';
import { WaterbodyDetailNoReports } from '../../components/waterbody_detail/waterbody_detail_sections/waterbody_detail_fishing_reports/waterbody_detail_no_reports';
import { isPending, LoadingState } from '../../constants/loading_state';
import styles from './fishing_reports_list.less';

interface FishingReportsListProps {
  fishingReports: FishingReport[];
  onLoadMore: () => void;
  loadingState: LoadingState;
  selectedSeasonGroup: SeasonGroup;
  selectedSpecies: Species;
  totalFishingReportsCount: number;
  totalFilteredReportsCount: number;
}
export const FishingReportsList = ({
  fishingReports,
  loadingState,
  onLoadMore,
  selectedSeasonGroup,
  selectedSpecies,
  totalFishingReportsCount,
  totalFilteredReportsCount,
}: FishingReportsListProps) => {
  const fishingReportsCount = fishingReports.length;

  const maxAvailableReports =
    selectedSeasonGroup || selectedSpecies ? totalFilteredReportsCount : totalFishingReportsCount;
  const showLoadMoreButton = fishingReportsCount < maxAvailableReports;

  useFishingReportListViewed(fishingReports, 'embedded', 0, fishingReportsCount);

  return (
    <>
      <ul className={styles.fishingReports}>
        {isPending(loadingState) ? (
          <Loading text="Loading Fishing Reports" color={'#fff'} className={styles.loading} />
        ) : fishingReports.length === 0 ? (
          <div className={styles.noReportsWrapper}>
            <WaterbodyDetailNoReports
              selectedSeasonGroup={selectedSeasonGroup}
              selectedSpecies={selectedSpecies}
            />
          </div>
        ) : (
          <div className={styles.frRows}>
            {fishingReports.map((report, i) => {
              return (
                <li key={report.id} className={styles.card}>
                  <MapFishingReportCard report={report} showLakeName={false} />
                </li>
              );
            })}
          </div>
        )}
      </ul>
      {showLoadMoreButton && !isPending(loadingState) ? (
        <div className={styles.loadMoreButton}>
          <OmniaButton size="lg" fontSize={14} kind="tertiary" onPress={onLoadMore}>
            Load More Fishing Reports
          </OmniaButton>
        </div>
      ) : (
        <Spacer size={50} />
      )}
    </>
  );
};
